export { getYearPredictionsZodiac } from "./getYearPredictionsZodiac";
